import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addToCart: {
    id: 'universals.add.to.cart',
    defaultMessage: 'Do košíku',
  },
});
